import React from "react";
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Radio,
  Select,
  Upload,
  Typography,
  Flex,
  message,
} from "antd";
import { InboxOutlined } from "@ant-design/icons";

import "react-phone-number-input/style.css";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import { css } from "@emotion/css";
import dayjs from "dayjs";
import { countries } from "../../../../../../../../shared-components/countries";
import PaperClipIcon from "../../../../../../../../Theme/CustomIcons/Icons/Type,Paragraph,Character/PaperClipIcon";
const { Dragger } = Upload;

const { TextArea } = Input;
const { Text } = Typography;

export const renderDynamicField = (
  question,
  index,
  dispatch,
  uploadDocumentCustomerDynamicFormAction,
  form
) => {
  const fieldName = ["formQuestions", index];

  const fieldColSpan = parseInt(question.fieldColSpan) || 24;
  let colSpan = 24;

  if (fieldColSpan >= 1 && fieldColSpan <= 24) {
    if (fieldColSpan === 1) {
      colSpan = 24;
    } else if (fieldColSpan === 2) {
      colSpan = 12;
    } else if (fieldColSpan === 3) {
      colSpan = 8;
    } else {
      colSpan = fieldColSpan;
    }
  } else {
    colSpan = 24;
  }

  const isRequired = question.requirement === "required";

  let fieldComponent = null;

  switch (question.answerType) {
    case "simpleText":
      fieldComponent = (
        <Form.Item
          name={[...fieldName, "answer"]}
          label={question.question}
          rules={
            isRequired
              ? [
                  {
                    required: true,
                    message: `${question.question} is required`,
                  },
                ]
              : []
          }
          tooltip={question.description || undefined}
          style={{ marginBottom: 8 }}
        >
          {colSpan >= 24 ? (
            <TextArea
              placeholder={question.placeholder || `Enter ${question.question}`}
              rows={4}
            />
          ) : (
            <Input
              placeholder={question.placeholder || `Enter ${question.question}`}
            />
          )}
        </Form.Item>
      );
      break;

    case "multiple-choice":
      const options = question.multiOptions || [];
      fieldComponent = (
        <Form.Item
          name={[...fieldName, "answer"]}
          label={question.question}
          rules={
            isRequired
              ? [
                  {
                    required: true,
                    message: `${question.question} is required`,
                  },
                ]
              : []
          }
          tooltip={question.description || undefined}
          style={{ marginBottom: 8 }}
        >
          <Select
            placeholder={question.placeholder || `Select ${question.question}`}
            mode="multiple"
            options={options.map((opt) => ({
              value: opt._id,
              label: opt.text,
            }))}
          />
        </Form.Item>
      );
      break;

    case "dropDown":
      const dropdownOptions = question.multiOptions || [];
      fieldComponent = (
        <Form.Item
          name={[...fieldName, "answer"]}
          label={question.question}
          rules={
            isRequired
              ? [
                  {
                    required: true,
                    message: `${question.question} is required`,
                  },
                ]
              : []
          }
          tooltip={question.description || undefined}
          style={{ marginBottom: 8 }}
        >
          <Select
            placeholder={question.placeholder || `Select ${question.question}`}
            options={dropdownOptions.map((opt) => ({
              value: opt._id,
              label: opt.text,
            }))}
          />
        </Form.Item>
      );
      break;

    case "radio":
      const radioOptions = question.multiOptions || [];
      fieldComponent = (
        <Form.Item
          name={[...fieldName, "answer"]}
          label={question.question}
          rules={
            isRequired
              ? [
                  {
                    required: true,
                    message: `${question.question} is required`,
                  },
                ]
              : []
          }
          tooltip={question.description || undefined}
          getValueFromEvent={(e) => e.target.value}
          style={{ marginBottom: 8 }}
        >
          <Radio.Group>
            {radioOptions.map((opt) => (
              <Radio key={opt._id} value={opt._id}>
                {opt.text}
              </Radio>
            ))}
          </Radio.Group>
        </Form.Item>
      );
      break;

    case "checkbox":
      const checkboxOptions = question.multiOptions || [];
      fieldComponent = (
        <Form.Item
          name={[...fieldName, "answer"]}
          label={question.question}
          rules={
            isRequired
              ? [
                  {
                    required: true,
                    message: `${question.question} is required`,
                  },
                ]
              : []
          }
          tooltip={question.description || undefined}
          style={{ marginBottom: 8 }}
          normalize={(value) => {
            // Ensure checkbox always returns an array
            if (value === null || value === undefined || value === "") {
              return [];
            }
            if (Array.isArray(value)) {
              return value;
            }
            // If single value, convert to array
            return [value];
          }}
          getValueFromEvent={(value) => {
            // Checkbox.Group returns an array directly
            if (Array.isArray(value)) {
              return value;
            }
            return value ? [value] : [];
          }}
        >
          <Checkbox.Group>
            {checkboxOptions.map((opt) => (
              <Checkbox key={opt._id} value={opt._id}>
                {opt.text}
              </Checkbox>
            ))}
          </Checkbox.Group>
        </Form.Item>
      );
      break;

    case "country":
      fieldComponent = (
        <Form.Item
          name={[...fieldName, "answer"]}
          label={question.question}
          rules={
            isRequired
              ? [
                  {
                    required: true,
                    message: `${question.question} is required`,
                  },
                ]
              : []
          }
          tooltip={question.description || undefined}
        >
          <Select
            placeholder={question.placeholder || `Select ${question.question}`}
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={countries.map((c) => ({ value: c, label: c }))}
          />
        </Form.Item>
      );
      break;

      {
        /* TODO
  This breaks the code need more testing
*/
      }
    case "phone":
      fieldComponent = (
        <Form.Item
          name={[...fieldName, "answer"]}
          label={question.question}
          rules={
            isRequired
              ? [
                  {
                    required: true,
                    message: `${question.question} is required`,
                  },
                ]
              : []
          }
          tooltip={question.description || undefined}
          style={{ marginBottom: 8 }}
          className={css`
            .PhoneInputInput {
              padding-left: 12px;
            }
          `}
        >
          <PhoneInputWithCountrySelect
            placeholder={question.placeholder || `Enter ${question.question}`}
            international
            defaultCountry="AE"
          />
        </Form.Item>
      );
      break;

    case "date":
      fieldComponent = (
        <Form.Item
          name={[...fieldName, "answer"]}
          label={question.question}
          rules={
            isRequired
              ? [
                  {
                    required: true,
                    message: `${question.question} is required`,
                  },
                ]
              : []
          }
          tooltip={question.description || undefined}
          style={{ marginBottom: 8 }}
          getValueFromEvent={(date) => {
            if (!date) return null;
            if (dayjs.isDayjs(date)) {
              return date.format("YYYY-MM-DD");
            }
            return date;
          }}
          normalize={(value) => {
            if (!value && value !== 0) return null;

            if (dayjs.isDayjs(value)) {
              return value.isValid() ? value : null;
            }

            if (value instanceof Date) {
              try {
                const parsed = dayjs(value);
                return parsed.isValid() ? parsed : null;
              } catch (error) {
                return null;
              }
            }

            if (typeof value === "string") {
              const trimmed = value.trim();
              if (
                trimmed === "" ||
                trimmed === "null" ||
                trimmed === "undefined"
              ) {
                return null;
              }
              try {
                const parsed = dayjs(trimmed);
                return parsed.isValid() ? parsed : null;
              } catch (error) {
                return null;
              }
            }

            if (typeof value === "number" && !isNaN(value)) {
              try {
                const parsed = dayjs(value);
                return parsed.isValid() ? parsed : null;
              } catch (error) {
                return null;
              }
            }

            return null;
          }}
        >
          <DatePicker
            placeholder={question.placeholder || `Select ${question.question}`}
            style={{ width: "100%" }}
            format="YYYY-MM-DD"
          />
        </Form.Item>
      );
      break;

    case "file":
      fieldComponent = (
        <Form.Item
          name={[...fieldName, "answer"]}
          label={question.question}
          rules={
            isRequired
              ? [
                  {
                    required: true,
                    message: `${question.question} is required`,
                  },
                ]
              : []
          }
          tooltip={question.description || undefined}
          valuePropName="fileList"
          style={{ marginBottom: 8 }}
          getValueFromEvent={(e) => {
            let fileList = [];
            if (Array.isArray(e)) {
              fileList = e;
            } else if (e?.fileList) {
              fileList = e.fileList;
            } else if (e?.file) {
              fileList = [e.file];
            }
            return fileList;
          }}
          normalize={(value) => {
            if (!value) return [];
            if (Array.isArray(value)) {
              return value;
            }
            return [value];
          }}
        >
          <Dragger
            beforeUpload={() => {
              return false;
            }}
            maxCount={1}
            onChange={async (info) => {
              const { fileList } = info;

              if (fileList.length > 0) {
                const fileItem = fileList[0];

                if (
                  fileItem.originFileObj &&
                  !fileItem.url &&
                  !fileItem.publicId
                ) {
                  const fileToUpload = fileItem.originFileObj;

                  if (
                    fileToUpload instanceof File &&
                    dispatch &&
                    uploadDocumentCustomerDynamicFormAction
                  ) {
                    try {
                      const hideLoading = message.loading({
                        content: `Uploading ${fileToUpload.name}...`,
                        key: `upload-${index}`,
                        duration: 0,
                      });

                      const uploadResult = await dispatch(
                        uploadDocumentCustomerDynamicFormAction(fileToUpload)
                      );

                      hideLoading();

                      const uploadedFileInfo = {
                        url: uploadResult?.url,
                        publicId: uploadResult?.publicId,
                      };

                      if (uploadedFileInfo?.url && uploadedFileInfo?.publicId) {
                        const updatedFileItem = {
                          ...fileItem,
                          url: uploadedFileInfo.url,
                          publicId: uploadedFileInfo.publicId,
                          status: "done",
                        };

                        form.setFieldValue(
                          [...fieldName, "answer"],
                          [updatedFileItem]
                        );

                        message.success({
                          content: "File uploaded successfully",
                          key: `upload-${index}`,
                          duration: 2,
                        });
                      } else {
                        message.error({
                          content:
                            "File upload failed: Missing URL or Public ID",
                          key: `upload-${index}`,
                          duration: 3,
                        });
                      }
                    } catch (error) {
                      message.error({
                        content: `Failed to upload file: ${
                          error?.message || "Unknown error"
                        }`,
                        key: `upload-${index}`,
                        duration: 3,
                      });
                    }
                  }
                }
              }
            }}
          >
            <Text>Click or drag file to this area to upload</Text>
          </Dragger>
          <Form.Item shouldUpdate noStyle>
            {({ getFieldValue }) => {
              const fileList = getFieldValue([...fieldName, "answer"]) || [];
              if (fileList.length > 0 && fileList[0]?.url) {
                const fileItem = fileList[0];
                const fileName =
                  fileItem.name || fileItem.publicId || "Uploaded File";
                return (
                  <Flex align="center" gap={4} style={{ marginTop: 8 }}>
                    <PaperClipIcon size="small" />
                    <Text
                      type="link"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (fileItem.url) {
                          window.open(fileItem.url, "_blank");
                        }
                      }}
                    >
                      Download Attachment
                    </Text>
                  </Flex>
                );
              }
              return null;
            }}
          </Form.Item>
        </Form.Item>
      );
      break;

    case "number":
      fieldComponent = (
        <Form.Item
          name={[...fieldName, "answer"]}
          label={question.question}
          rules={
            isRequired
              ? [
                  {
                    required: true,
                    message: `${question.question} is required`,
                  },
                ]
              : []
          }
          tooltip={question.description || undefined}
          style={{ marginBottom: 8 }}
          normalize={(value) => {
            if (value === null || value === undefined || value === "") {
              return undefined;
            }
            const numValue = Number(value);
            return isNaN(numValue) ? undefined : numValue;
          }}
        >
          <InputNumber
            placeholder={question.placeholder || `Enter ${question.question}`}
            style={{ width: "100%" }}
            min={question.min !== undefined ? Number(question.min) : undefined}
            max={question.max !== undefined ? Number(question.max) : undefined}
            step={question.step !== undefined ? Number(question.step) : 1}
          />
        </Form.Item>
      );
      break;

    default:
      fieldComponent = (
        <Form.Item
          name={[...fieldName, "answer"]}
          label={question.question}
          rules={
            isRequired
              ? [
                  {
                    required: true,
                    message: `${question.question} is required`,
                  },
                ]
              : []
          }
          tooltip={question.description || undefined}
          style={{ marginBottom: 8 }}
        >
          <Input
            placeholder={question.placeholder || `Enter ${question.question}`}
          />
        </Form.Item>
      );
  }

  return (
    <Col span={colSpan} key={question._id || index}>
      {fieldComponent}
    </Col>
  );
};
